// extracted by mini-css-extract-plugin
export var anchor = "styles-module--anchor--c1420";
export var container = "styles-module--container--34989";
export var orderedListItem = "styles-module--orderedListItem--b0490";
export var unorderedListItem = "styles-module--unorderedListItem--ae42c";